import { useEffect, useState } from 'react';

import { listDeviceParameters } from '../../utils/sensors';
import { useGetDeviceMetricsQuery } from '../../store/api/sensors';
import { Loading } from '../index.jsx';
import { DeviceInfoItem } from '../GlobalComponents/index.jsx';

const DevicesInfo = ({ t, id, gps = [] }) => {
  const [deviceId, setDeviceId] = useState('');
  const [parameters, setParameters] = useState([]);
  const { data: device, isSuccess: isGetAboutDeviceSuccess } = useGetDeviceMetricsQuery(
    { id: id },
    { skip: !id },
  );

  useEffect(() => {
    if (device && device.id !== deviceId) {
      setDeviceId(device.id);
      setParameters(listDeviceParameters({ t, device, gps }));
    }
  }, [device, deviceId, isGetAboutDeviceSuccess])

  if (parameters.length === 0 && !isGetAboutDeviceSuccess) {
    return <Loading isHeightAuto={true} />
  }

  const listItems = parameters.map((item, index) => (
    <DeviceInfoItem key={index} title={item.title} value={item.data} />
  ));

  return <div>{listItems}</div>;
};

export default DevicesInfo;